import React, { useEffect, useState } from "react";
import { FundExpenseDetailForm } from "../../../types/formTypes"
import { FormField, ButtonField, UploadedFileListProps, UploadedFileProps } from "../../../types/types"
import { useNavigate, useParams } from "react-router-dom";
import { useLoader } from "../../../Loader/LoaderContext";
import { useGet } from "../../../services/hooks/useGet";
import { GetUrl, configPutHeader, PostUrl } from "../../../api/endpointConfig";
import { API_URL, API_VERSION, BLOB_API } from "../../../config/config";
import axios from "axios";
import {
  TableColumn,
} from "../../../components/CommnTable/CustomDataTable";
import { Box, IconButton, Button } from "@mui/material"
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import { useMutationByMethod } from "../../../services/hooks/useMutationByMethod";
import { ToastService } from "../../../utils/toastService";
import { useFundContext } from "../../../Context/FundManagementContext";
import { blue } from '@mui/material/colors';

const useFundExpenseDetail = () => {
  const navigate = useNavigate()
  const { id, type } = useParams();
  const { showLoader, hideLoader } = useLoader();
  const [open, setOpen] = useState(false);
  const userData: any = JSON.parse(localStorage.getItem("userData") || "{}")
  const { fundDetail } = useFundContext()
  const [showReason, setShowRason] = useState(false)
  const [reasonType, setReasonType] = useState('')
  const [file, setFile] = useState<UploadedFileProps[]>([]);
  const [reason, setReason] = useState('')
  const [submitType, setSubmitType] = useState('')

  const { data = [], isLoading, isError } = useGet<any>(
    `${GetUrl.getExpenseSummaryDetails}/${id}`, undefined,
    type === "view"
  );

  const scholarship_id = type === "view" ? id : type

  const { data:purpose = [], isLoading:purposeLoading, isError:purposeError } = useGet<any>(
    `${GetUrl.getFundAllocationList}/${scholarship_id ||userData?.scholarship_id}/form-data`
  );

  const { mutate } = useMutationByMethod<any>(
    "post",
    `${PostUrl.postExpense}/${Number(type)}`
  );

  const { mutate: updateRecipe } = useMutationByMethod<any>(
    "patch",
    `${PostUrl.postExpense}/${Number(id)}`
  );


  const { mutate: ApproveRecipt } = useMutationByMethod<any>(
    "post",
    `${PostUrl.postExpense}/${Number(id)}/${submitType}`,
    {
      params: {
        verification_comments: reason,
        expense_id: `${Number(id)}`
      },
    }
  );

  useEffect(() => {
    if (isLoading && !isError) {
      showLoader()
    } else if (isError) { hideLoader() }
    else {

      hideLoader()
    }
  }, [isLoading, isError])

  const handleReciptClick = (data: any) => {
    setOpen(true)
  }

  const handleView = (file: string = "") => {
    window.open(file, '_blank');
  }

  const handleDeleteRow = (filename: string) => {
    setFile((prevRows) => prevRows.filter((row) => row.filename !== filename));
  };

  const handleDownload = async (fileUrl: string = '', fileName: string = '', file: File) => {
    try {
      const response = await axios.get(fileUrl, {
        responseType: "blob",
      });
      const blob = new Blob([response.data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(link.href);
    } catch (err) {
      console.error("Download failed", err);
    }
  };

  const columns: TableColumn<UploadedFileListProps>[] = [
    { field: "filename", header: "File Name", width: "16rem" },
    { field: "fileType", header: "File Type", width: "4rem", customBody: (row) => <Box>{row.fileType === 'application/pdf' ? 'PDF Document' : 'Image File'}</Box> },
    {
      field: "action", header: "Action", width: "4rem", customBody: (row) => <Box><IconButton
        edge="end"
        title="View"
        color='info'
        size='large'
        onClick={() => handleView(row.secureBlobUrl)}
      >
        <VisibilityIcon />
      </IconButton>
        <IconButton
          edge="end"
          title="Delete"
          component="a"
          size='large'
          color='warning'
          onClick={() => handleDeleteRow(row.filename)}
        >
          <DeleteIcon />
        </IconButton></Box>
    }
  ]

  const ViewReceiptColumn: any[] = [
    {
      field: "file_name", header: "File Name", width: "16rem"
    },
    {
      field: "action", header: "Action", width: "4rem", customBody: (row: any) => (
        <Button variant="contained" sx={{ bgcolor: blue[700], width: "70%" }} onClick={() =>
           window.open(row.url, '_blank')
        }>View</Button>
      )
    }
  ]

  const fundsFormFields: FormField<FundExpenseDetailForm>[] = [
    { name: 'expense_purpose', defaultValue: data.expense_purpose, disabled: type === "view", text_label: 'Purpose', options: purpose?.purpose, type: 'select', validate: (val: any) => val.length == 0 && "purpose is required " },
    { name: 'expense_date', text_label: 'Date', type: 'date', defaultValue: data.expense_date },
    { name: 'amount', text_label: 'Amount', type: 'number', defaultValue: data.amount },
    { name: "receipt_url", text_label: type === "view" ? ' View Recipt' : 'Upload Recipt', defaultValue: data.receipt_url, type: 'button', onClick: handleReciptClick },
  ];
  if (type === "view" && data.status !== 'submitted') {
    fundsFormFields.push({ name: 'verification_comments', text_label: 'Remark', type: 'text', defaultValue: data.verification_comments })
  }
  const handleUploadReceipt = async (filedata: File) => {
    showLoader()
    try {
      const extension = filedata.name.split(".").pop()?.toLowerCase() || "pdf";

      const base64 = await new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const result = reader.result as string;
          resolve(result.split(",")[1]);
        };
        reader.onerror = reject;
        reader.readAsDataURL(filedata);
      });

      const buffer = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));

      const { data: sastokenInfo } = await axios.get(
        `${API_URL}/${API_VERSION}/${GetUrl.getSasToken}?file_type=${extension}`
      );

      const uploadUrl = `${BLOB_API}/documents/${sastokenInfo.filename}?${sastokenInfo.token}`;
      const putRes = await axios.put(uploadUrl, buffer, configPutHeader(filedata));

      if (![200, 201].includes(putRes.status)) {
        console.warn(`Upload failed for ${filedata.name}`);
      }

      const { data: accessTokenInfo } = await axios.get(
        `${API_URL}/${API_VERSION}/${GetUrl.getSasTokenFile}?file_name=${sastokenInfo.filename}`
      );

      const secureBlobUrl = `${BLOB_API}/documents/${sastokenInfo.filename}?${accessTokenInfo.token}`;
      const blobFileUrl = `${BLOB_API}/documents/${sastokenInfo.filename}`;
      setFile(prev => [...prev, {
        blobFileUrl: blobFileUrl,
        secureBlobUrl: secureBlobUrl,
        filename: sastokenInfo.filename,
        fileType: filedata.type,
        file: filedata
      }])
    } catch (err) {
      console.error("Upload failed:", err);
    } finally {
      hideLoader()
    }

  }

  const UpdateStatueApi = async () => {
    ApproveRecipt(null, {
      onSuccess: (data: any) => {
        hideLoader()
        ToastService.success(`Expense has been '${submitType}' successfully.`);
      },
      onError: (err: any) => {
        hideLoader()
        console.error("error", err);
        ToastService.error(err)
      }
    })
  }

  const handleAddReceipt = async (request_body: FundExpenseDetailForm) => {
    request_body.receipt_url = file.map(d => d.secureBlobUrl)
    showLoader()
    if (id === "add") {
      mutate(request_body, {
        onSuccess: (data: any) => {
          hideLoader()
          ToastService.success('Receipt has been added successfully.');
        },
        onError: (err: any) => {
          hideLoader()
          console.error("error", err);
          ToastService.error(err)
        },
      })
    } else {
      const body =
      {
        expense_purpose: data.expense_purpose,
        amount: data.amount,
        expense_date: data.expense_date,
        receipt_url: data.receipt_url.map((data:any) => data.url)
      }
      updateRecipe(body, {
        onSuccess: (data: any) => {
          hideLoader()
          ToastService.success('Receipt has been update successfully.');
        },
        onError: (err: any) => {
          hideLoader()
          console.error("error", err);
          ToastService.error(err)
        },
      })
    }
    hideLoader()
  }

  const handleApproveRecipet = (reason: string) => {
    setShowRason(false)
    showLoader()
    setReason(reason)
    UpdateStatueApi()
  }

  const handleRejectRecipet = (reason: string) => {
    setShowRason(false)
    showLoader()
    setReason(reason)

    UpdateStatueApi()
  }

  const buttonList: ButtonField[] = userData.role_id == 2 ? [
    { "name": "Submit", onClick: (data) => handleAddReceipt(data), ButtonColor: 'success', disabled: ['approved', 'reject'].includes(data.status) },
   ] : [
    { "name":  id === "add" ? "Submit" : "Update", onClick: (data) => handleAddReceipt(data), ButtonColor: 'success', disabled: ['approved', 'reject'].includes(data.status) },
    {
      "name": "Approved", onClick: () => {
        setSubmitType('approve')
        setShowRason(true)
      }, ButtonColor: 'info', disabled: id === "add" || ['approved', 'reject'].includes(data.status)
    },
    {
      "name": "Reject", onClick: () => {
        setShowRason(true)
        setSubmitType('reject')
      }, ButtonColor: 'error', disabled: ['approved', 'reject'].includes(data.status) || id === "add"
    }]

  return { data, fundDetail,userData, fundsFormFields,purposeLoading,purposeError, ViewReceiptColumn, buttonList, open, isLoading, isError, setOpen, columns, submitType, handleRejectRecipet, handleDownload, id, type, handleUploadReceipt, file, showReason, setShowRason, handleApproveRecipet }
}

export default useFundExpenseDetail